/**
 * Constants for Document Extract API
 */

/**
 * API endpoint paths
 */
export const DOCUMENT_EXTRACT_ENDPOINTS = {
  AUTH: '/auth/session',
  EXTRACT: '/extract',
  HEALTH: '/health'
} as const;

/**
 * Token validity duration (55 minutes in milliseconds)
 * Token is cached for 55 minutes to ensure validity before 60-minute expiry
 */
export const TOKEN_VALIDITY_MS = 55 * 60 * 1000;

/**
 * HTTP timeout for API requests (in milliseconds)
 */
export const API_TIMEOUT_MS = 30000; // 30 seconds

/**
 * Error messages
 */
export const DOCUMENT_EXTRACT_ERRORS = {
  AUTHENTICATION_FAILED: 'Failed to authenticate with Document Extract API',
  EXTRACTION_FAILED: 'Failed to extract document data',
  NETWORK_ERROR: 'Network error occurred while communicating with Document Extract API',
  INVALID_FILE: 'Invalid file provided for extraction',
  INVALID_DOCUMENT_TYPE: 'Invalid or unsupported document type',
  TIMEOUT: 'Request timed out. Please try again.',
  UNKNOWN_ERROR: 'An unknown error occurred during document extraction',
  TOKEN_EXPIRED: 'Authentication token has expired',
  SCHEMA_NOT_FOUND: 'Schema not found for the specified document type',
  NO_FILE_PROVIDED: 'No file provided for extraction',
  API_URL_NOT_CONFIGURED: 'Document Extract API URL is not configured'
} as const;

/**
 * Success messages
 */
export const DOCUMENT_EXTRACT_SUCCESS = {
  EXTRACTION_COMPLETE: 'Document extracted successfully',
  AUTHENTICATION_SUCCESS: 'Authentication successful'
} as const;

/**
 * HTTP status codes
 */
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503
} as const;

/**
 * Loading indicators
 */
export const LOADING_INDICATORS = {
  AUTHENTICATING: 'docextract-auth',
  EXTRACTING: 'docextract-extract',
  HEALTH_CHECK: 'docextract-health'
} as const;

